<template>
  <v-list-item
    :title="t('support-site')"
    class="ma-0"
    @click="goToSupport"
    :disabled="loading"
  >
    <template v-slot:prepend>
      <v-icon v-if="!loading">mdi-lifebuoy</v-icon>
      <v-progress-circular v-else :size="25" indeterminate class="mr-4" />
    </template>
  </v-list-item>

  <CrewSupportModal v-if="showCrewModal" v-model="showCrewModal" />
</template>
<script setup>
import { ref } from 'vue';
import { baseGet } from '../../helpers/api';
import { useRootStore } from '../../stores/root';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import CrewSupportModal from '../CrewSupportModal.vue';
const { t } = useI18n();

const clientDict = {
  McDonalds: 'https://qsrsoft.zendesk.com/access/jwt?jwt=',
  TimHortons: 'https://qsrsoft.zendesk.com/access/jwt?jwt=',
  Popeyes: 'https://qsrsoft.zendesk.com/access/jwt?jwt=',
};

const returnDict = {
  McDonalds: '&return_to=https://qsrsoft.zendesk.com/hc/en-us/',
  TimHortons: '&return_to=https://qsrsoft-timhorton.zendesk.com/hc/en-us/',
  Popeyes: '&return_to=https://qsrsoft-popeyes.zendesk.com/hc/en-us/',
};

const loading = ref(false);
async function getToken() {
  const { token } = await baseGet('token/zendesk');
  return token;
}

const store = useRootStore();
const { enterpriseClient, isCrewMember } = storeToRefs(store);
const showCrewModal = ref(false);

async function goToSupport() {
  // Check if user is a crew member and show popup instead
  if (isCrewMember.value) {
    showCrewModal.value = true;
    return;
  }

  loading.value = true;
  const token = await getToken();
  const helpUrlBase = `${clientDict[enterpriseClient.value]}${token}${returnDict[enterpriseClient.value]}`;

  if (store.onMobileApp) {
    window.open(helpUrlBase, '_self');
  } else {
    window.open(helpUrlBase, '_blank');
  }

  loading.value = false;
}
</script>
<i18n>
{
  "en": {
    "support-site": "Support Site"
  },
  "es": {
    "support-site": "Sitio de Soporte"
  }
}
</i18n>
